export function ErrorMessage({ error }: { error: string | null }) {
	if (!error) {
		return null
	}
	return <p className="text-center text-destructive text-sm">{error}</p>
}
